export const Hungarian = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'Ő', 'Ú', 'Ű'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'É', 'Á'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
]
